import { styled } from '@mui/material';

export const SubtitleWrap = styled('div')`
  position: absolute;
  width: 100%;
  text-align: center;
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;

  .subtitles-text {
    color: white;
    padding: 5px;
    position: relative;
    z-index: 1;
  }
  .subtitles-bg {
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
  }
`;
